import getList from './getList'
import { ItemList } from '../../../objects/itemList'

interface GetListHandlesOptions {
  paginate?: boolean
  selectedList?: string
  index?: number
  itemsPerPage?: number
}

export default (
  lists: Array<ItemList>,
  options: GetListHandlesOptions = {}
): Array<string> => {
  const { paginate, selectedList, index = 0, itemsPerPage = 30 } = options
  const list = getList(selectedList, lists)

  if (list && list.handles) {
    if (paginate) {
      return list.handles.slice(index, index + itemsPerPage)
    }

    return list.handles
  }

  throw new Error('Selected list does not have array of handles')
}
